import React from 'react';
import { useNavigate } from 'react-router-dom';
import FishListRow from '../FishListRow';
import { useModal } from '../../contexts/modal';

const FishTable = ({
  fish,
  isEditable = false,
  isSelectable = false,
  isClickable = true,
  editingData = {},
  onEditClick,
  onSaveClick,
  onCancelClick,
  onInputChange,
  selectedFishIds = [],
  onCheckboxChange,
  onSelectAllChange,
  handleCellClickDestination = null,
}) => {
  const navigate = useNavigate();
  const { isModalOpen, closeModal } = useModal();

  const handleCellClick = (fishId, destination = null) => {
    if (!editingData.id && !destination) {
      if (isModalOpen) {
        closeModal();
      }
      navigate(`/guests/${fishId}`);
    } else if (!editingData.id && destination === 'members') {
      if (isModalOpen) {
        closeModal();
      }
      navigate(`/${destination}/${fishId}`);
    }
  };

  const allSelected = fish.length > 0 && selectedFishIds.length === fish.length;
  const isSelected = (fishId) => selectedFishIds.includes(fishId);

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full border border-gray-200 bg-white">
        <thead>
          <tr>
            {isSelectable && (
              <th className="border-b px-4 py-2">
                <input
                  type="checkbox"
                  onChange={onSelectAllChange}
                  checked={allSelected}
                />
              </th>
            )}

            {/*Needed to customize different order of the columns for segmentReview, using handleCecllClickDestination to know*/}
            {handleCellClickDestination !== 'members' ? (
              <>
                <th className="border-b px-4 py-2 text-left text-sm font-medium text-gray-700">
                  Email
                </th>
                <th className="border-b px-4 py-2 text-left text-sm font-medium text-gray-700">
                  First Name
                </th>
                <th className="border-b px-4 py-2 text-left text-sm font-medium text-gray-700">
                  Last Name
                </th>
                <th className="border-b px-4 py-2 text-left text-sm font-medium text-gray-700">
                  Phone Number
                </th>
              </>
            ) : (
              <>
                <th className="border-b px-4 py-2 text-left text-sm font-medium text-gray-700">
                  First Name
                </th>
                <th className="border-b px-4 py-2 text-left text-sm font-medium text-gray-700">
                  Last Name
                </th>
                <th className="border-b px-4 py-2 text-left text-sm font-medium text-gray-700">
                  Phone Number
                </th>
                <th className="border-b px-4 py-2 text-left text-sm font-medium text-gray-700">
                  Email
                </th>
              </>
            )}

            {isEditable && (
              <th className="border-b px-4 py-2 text-left text-sm font-medium text-gray-700">
                Actions
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {fish.map((fishItem) => {
            const isEditing = editingData.id === fishItem.id;
            return (
              <FishListRow
                key={fishItem.id}
                fish={fishItem}
                isEditing={isEditing}
                editingValues={isEditing ? editingData : {}}
                handleCellClick={isClickable ? handleCellClick : () => {}}
                handleInputChange={onInputChange}
                handleSaveClick={onSaveClick}
                handleCancelClick={onCancelClick}
                handleEditClick={onEditClick}
                isSelected={isSelected}
                handleCheckboxChange={onCheckboxChange}
                showCheckbox={isSelectable}
                showActions={isEditable}
                isClickable={isClickable}
                handleCellClickDestination={handleCellClickDestination}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FishTable;
